import { createClient } from '@liveblocks/client';
import { createRoomContext } from '@liveblocks/react';
import { liveblocksPublicKey } from 'config';

const client = createClient({
  publicApiKey: liveblocksPublicKey,
});

export const {
  suspense: { RoomProvider, useRoom, useOthers, useSelf, useStorage },
} = createRoomContext(client);
